module.exports = __webpack_public_path__ + "static/media/4029.2062f47f.jpg";